import { createSlice } from '@reduxjs/toolkit';

export type ConnectPrayerStreamUserState = {
  pending: boolean;
};

const initialState: ConnectPrayerStreamUserState = {
  pending: false,
};

export const connectPrayerStreamUserSlice = createSlice({
  initialState,
  name: 'connectPrayerStreamUser',
  reducers: {
    connectPrayerStreamUserRequested: () => {},
    connectPrayerStreamUserReset: () => {
      return initialState;
    },
    connectPrayerStreamUserStarted: (state) => {
      state.pending = true;
    },
    connectPrayerStreamUserSucceeded: (state) => {
      state.pending = false;
    },
  },
});
